/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.hint-message-drag[_ngcontent-%COMP%] {\n  text-align: right;\n  padding: 8px; }\n\n.text-info[_ngcontent-%COMP%] {\n  width: 100%; }\n\np-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] {\n  width: 100%; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvd29yay1leHBlcmllbmNlcy9uZXctd29yay1leHBlcmllbmNlL25ldy13b3JrLWV4cGVyaWVuY2UuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvd29yay1leHBlcmllbmNlcy9uZXctd29yay1leHBlcmllbmNlL25ldy13b3JrLWV4cGVyaWVuY2UuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/work-experiences/new-work-experience/new-work-experience.component.scss.shim.ngstyle.ts